import { api } from "@/features/auth/api";

export type CartLine = {
    product_id: string;
    slug: string;
    name: string;
    brand: string;
    price: number;
    mrp: number;
    weight: string;
    tone: string[];
    glyph: string;
    quantity: number;
    stock_count: number;
    in_stock: boolean;
    images?: string[];
    show_picture?: boolean;
};

export type Cart = {
    items: CartLine[];
    saved_for_later: CartLine[];
    subtotal: number;
    mrp_total: number;
    total_savings: number;
    total_items: number;
};

export const cartApi = {
    get: async (): Promise<Cart> => (await api.get<Cart>("/cart")).data,
    add: async (product_id: string, quantity = 1): Promise<Cart> =>
        (await api.post<Cart>("/cart/items", { product_id, quantity })).data,
    setQuantity: async (product_id: string, quantity: number): Promise<Cart> =>
        (await api.patch<Cart>(`/cart/items/${product_id}`, { quantity })).data,
    remove: async (product_id: string): Promise<Cart> =>
        (await api.delete<Cart>(`/cart/items/${product_id}`)).data,
    clear: async (): Promise<Cart> => (await api.post<Cart>("/cart/clear")).data,
    saveForLater: async (product_id: string): Promise<Cart> =>
        (await api.post<Cart>(`/cart/save-for-later/${product_id}`)).data,
    restore: async (product_id: string): Promise<Cart> =>
        (await api.post<Cart>(`/cart/save-for-later/${product_id}/restore`)).data,
    merge: async (items: Array<{ product_id: string; quantity: number }>): Promise<Cart> =>
        (await api.post<Cart>("/cart/merge", { items })).data,
};
